import React, { useEffect } from 'react';
import classNames from 'classnames/bind';
import { Button } from '@carnica/ui-kit';
import { connect } from 'react-redux';
import { IconChevronDown, IconChevronUp } from '@carnica/graphics';
import { compose } from '@beef/redux';
import { Metric } from "../../../../../utils/metric";
import { selectAccountType, selectHasMainBalanceError, selectIsBalanceListOpen, selectMainBalance, selectMainBalanceLoading, selectNeedSendPostMessage } from "../../store/selectors";
import { selectBaseUrl } from "../../../../../store/selectors";
import styles from "./styles.pcss";
import { ConnectionBlockActionCreator } from "../../store/actions";
import { BalanceChoose } from "./components/BalanceChoose";
import { BalanceError } from "../BalanceError";
import { BalancesSelect } from "./components/BalancesSelect";
import { BalanceLoading } from "./BalanceLoading";
var cn = classNames.bind(styles);
var _Balance = function _Balance(_ref) {
  var hasError = _ref.hasError,
    isBalanceListOpen = _ref.isBalanceListOpen,
    isPending = _ref.isPending,
    userType = _ref.userType,
    baseUrl = _ref.baseUrl,
    mainBalance = _ref.mainBalance,
    onBalanceListOpen = _ref.onBalanceListOpen,
    onRefreshBalance = _ref.onRefreshBalance,
    requiresPostMessage = _ref.requiresPostMessage;
  var handlePaymentClick = function handlePaymentClick() {
    window.location.href = "".concat(baseUrl, "?payment");
  };
  useEffect(function () {
    if (window.location.href.indexOf('elk') > -1 && requiresPostMessage) {
      var customEvent = new CustomEvent('fetchBalance', {
        detail: mainBalance
      });
      window.dispatchEvent(customEvent);
    }
  }, [requiresPostMessage]);
  var handleBalanceClick = function handleBalanceClick() {
    onBalanceListOpen(isBalanceListOpen ? null : 'BalanceListModal');
  };
  if (hasError) {
    return /*#__PURE__*/React.createElement("div", {
      className: cn('container', 'wrapper'),
      "data-t-id": "components-Balance"
    }, /*#__PURE__*/React.createElement(BalanceError, {
      onClick: onRefreshBalance
    }));
  }
  if (isPending) {
    return /*#__PURE__*/React.createElement(BalanceLoading, null);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cn('container')
  }, !!mainBalance && /*#__PURE__*/React.createElement(BalancesSelect, {
    onClickOutside: function onClickOutside() {
      return onBalanceListOpen(null);
    },
    showBalances: isBalanceListOpen
  }, /*#__PURE__*/React.createElement(BalanceChoose, {
    iconRight: isBalanceListOpen ? IconChevronUp : IconChevronDown,
    onClick: handleBalanceClick,
    "data-t-id": "components-Balance"
  })), (mainBalance === null || mainBalance === void 0 ? void 0 : mainBalance.refillable) && /*#__PURE__*/React.createElement(Metric, {
    data: JSON.stringify({
      userType: userType
    }),
    events: {
      fubMetricSideMenu: ['handlePaymentClick']
    },
    mode: "click"
  }, /*#__PURE__*/React.createElement(Button, {
    className: cn('btn'),
    onClick: handlePaymentClick,
    size: "m",
    "data-t-id": "components-Balance"
  }, "\u043F\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u044C")));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    mainBalance: selectMainBalance(state),
    isPending: selectMainBalanceLoading(state),
    hasError: selectHasMainBalanceError(state),
    userType: selectAccountType(state),
    baseUrl: selectBaseUrl(state),
    isBalanceListOpen: selectIsBalanceListOpen(state),
    requiresPostMessage: selectNeedSendPostMessage(state)
  };
};
var mapDispatchToProps = {
  onRefreshBalance: ConnectionBlockActionCreator.fetchBalance,
  onBalanceListOpen: ConnectionBlockActionCreator.setOpenedModal
};
var connector = connect(mapStateToProps, mapDispatchToProps);
export var Balance = compose(connector)(_Balance);